import debounce from 'lodash/debounce';
import React, { useState } from 'react';
import { useReframe } from 'nike-re-framejs';

import { Button } from 'nike-ui/src/components/button/Button';
import i18n from '@i18n';
import SavedTicketNoCircleIcon from 'nike-ui/src/icons/svg/saved-ticket-no-circle-icon-sv.svg';
import { copyTicketToSaved } from '@/mytickets/detail/api';
import PopupNg from '@/ui/PopupNg';
import { loggedIn$ } from '@/account/subs';

export default function Save({ ticketId }) {
    const { subscribe } = useReframe();
    const loggedIn = subscribe(loggedIn$);
    const [btnState, setBtnState] = useState('READY');
    const debouncedSetBtnState = debounce(setBtnState, 300);
    const disabled = btnState !== 'READY';

    //zmena medzi SAVED a READY je pribrzdena, aby to nepekne neblikalo
    function onTickedSaved() {
        debouncedSetBtnState('SAVED');
        setTimeout(() => debouncedSetBtnState('READY'), 1500);
    }
    function onClick() {
        PopupNg.dispatcher.close('ticketDetail');

        if (loggedIn) {
            setBtnState('SAVING');
            copyTicketToSaved(ticketId).finally(onTickedSaved);
        } else {
            const bodyText = i18n('tickets.login-4-ticket-copy');
            PopupNg.dispatcher.open('dialog/login4action', { bodyText }, 20);
        }
    }
    return (
        <Button
            className="blue"
            dataAtid="ticket-detail-add-to-saved"
            label={getButtonText(btnState)}
            icon={SavedTicketNoCircleIcon}
            disabled={disabled}
            onClick={onClick}
        />
    );
}

function getButtonText(buttonState) {
    switch (buttonState) {
        case 'SAVING':
            return i18n('ticket.saving');
        case 'SAVED':
            return i18n('ticket.added-2-saved');
        default:
            return i18n('ticket.add-2-saved');
    }
}
